export { default as FeaturesSection } from './FeaturesSection--cms';
export { default as FeaturesSectionItem } from './FeaturesSectionItem';
export {
  mvpFeatureSectionAdapter,
  mvpFeatureSectionItemAdapter,
} from './adapters';
